<template>
  <v-dialog v-model="dialog" max-width="550">
    <v-card>
      <v-btn
        icon
        @click="dialog = false"
        style="position: absolute; right: 0; top: 1px"
        color="#fff;"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-title>{{ $t("editGroup") }}</v-card-title>
      <v-card-text>
        <validation-observer v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(save)">
            <div class="mb-2 d-flex align-center">
              <vue-select
                style="width: 100%"
                class="product-select-in-modal"
                @item-resolved="setProduct"
                :name="$t('product')"
                :label="$t('product')"
                rules="required"
                @input="onSelectProduct"
                v-model="formData.product_id"
                :getItemPromise="
                  ({ text, page }) =>
                    $store.dispatch('getProducts', {
                      name: text,
                      page,
                      limit: 15,
                    })
                "
                :items="products"
                @next-page-resolved="
                  (data) => setProduct([...products, ...data])
                "
                infinite
              >
                <template #option="{ item }">
                  <v-list-item-title>
                    <p class="ma-0">{{ item.name }}</p>
                    <span class="v-messages">{{
                      item.attrs.join(" && ")
                    }}</span>
                  </v-list-item-title>
                </template>
              </vue-select>
              <div
                class="d-flex align-center pt-6"
                v-if="child.productId !== formData.product_id"
              >
                <v-btn
                  class="new_style"
                  @click="refreshItem(child.productId, 'product')"
                >
                  <vue-icon icon="newRefreshIcon" />
                </v-btn>
                <span
                  class="text-decoration-line-through custom_input_label mb-0"
                  >{{ child.productName }}</span
                >
              </div>
            </div>
            <div class="mb-2 d-flex">
              <custom-select
                style="width: 100%"
                v-model="formData.unitTypeId"
                :item-text="`name_${$i18n.locale}`"
                :items="unitTypes"
                :label="$t('measure')"
                :name="$t('measure')"
                class="user_input no-margin"
                rules="required"
              ></custom-select>
              <div
                class="d-flex align-center pt-6"
                v-if="+child.unitTypeId !== formData.unitTypeId"
              >
                <v-btn
                  class="new_style"
                  @click="refreshItem(+child.unitTypeId, 'unitType')"
                >
                  <vue-icon icon="newRefreshIcon" />
                </v-btn>
                <span
                  class="text-decoration-line-through custom_input_label mb-0"
                  >{{ child[`unit_type_name_${$i18n.locale}`] }}</span
                >
              </div>
            </div>
            <div class="mb-2 d-flex">
              <custom-input-text
                style="width: 100%"
                v-model="formData.count"
                :label="$t('count')"
                :name="$t('count')"
                class="user_input no-margin"
                rules="required"
                @keydown="numberOnly"
              ></custom-input-text>
              <div
                class="d-flex align-center pt-6"
                v-if="child.count.replace('.', ',') !== formData.count"
              >
                <v-btn
                  class="new_style"
                  @click="refreshItem(child.count.replace('.', ','), 'count')"
                >
                  <vue-icon icon="newRefreshIcon" />
                </v-btn>
                <span
                  class="text-decoration-line-through custom_input_label mb-0"
                  >{{ child.count }}</span
                >
              </div>
            </div>
            <div class="my-1">
              <validation-provider
                :name="$t('file')"
                rules="required"
                v-slot="{ errors }"
              >
                <v-file-input
                  v-model="formData.file"
                  :error-messages="errors[0]"
                  clearable
                />
              </validation-provider>
            </div>
            <div class="mb-2">
              <custom-text-textarea
                :name="$t('comment')"
                rules="required"
                class="user_input"
                :label="$t('comment')"
                v-model="formData.comment"
              />
            </div>
            <div class="text-right">
              <v-btn :loading="loading" color="primary" type="submit">{{
                $t("save")
              }}</v-btn>
            </div>
          </form>
        </validation-observer>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { numberOnly } from "@/utils/inputRegExps";
import VueSelect from "@/components/ui/vue-select/VueSelect";

export default {
  name: "edit-order-item-dialog",
  components: { VueSelect },
  data() {
    return {
      dialog: false,
      loading: false,
      formData: {
        product_id: null,
        unitTypeId: null,
        count: null,
        id: null,
        comment: null,
        file: null,
      },
      products: [],
      child: {},
    };
  },
  methods: {
    setProduct(products) {
      this.products = products;
    },
    refreshItem(item, check) {
      if (check === "product") {
        this.formData.product_id = item;
      }
      if (check === "unitType") {
        this.formData.unitTypeId = item;
      }
      if (check === "count") {
        this.formData.count = item;
      }
    },
    onSelectProduct() {
      if (this.unitTypes.length === 1) {
        this.formData.unitTypeId = this.unitTypes[0].id;
      }
    },
    open(child) {
      this.child = {
        productId: child.productId,
        productName: child.productName,
        unitTypeId: child.unitTypeId,
        unit_type_name_en: child.unit_type_name_en,
        count: child.count,
      };
      const {
        productId: product_id,
        unitTypeId,
        count,
        productName,
        id,
      } = child;
      this.formData = {
        product_id,
        id,
        count: count.replace(".", ","),
        unitTypeId: +unitTypeId,
      };
      this.dialog = true;
      const product = this.products.find((item) => {
        return item.id === product_id;
      });
      if (!product) {
        this.$store
          .dispatch("getProducts", { name: productName })
          .then(({ data }) => {
            this.products = data;
          });
      }
    },
    async save() {
      this.loading = true;
      try {
        const form = { ...this.formData };
        const formData = new FormData();
        form.count = form.count.replace(",", ".");
        formData.append("file", form.file);
        formData.append("product_id", form.product_id);
        formData.append("unitTypeId", form.unitTypeId);
        formData.append("count", form.count);
        formData.append("id", form.id);
        formData.append("comment", form.comment);
        const {
          data: { data },
        } = await this.$http.post("orders/ozl-offer", formData);
        this.$emit("changed", data);
        this.dialog = false;
        this.setSuccess({ text: this.$t("successfullySaved") });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    try {
      const { data: products } = await this.$store.dispatch("getProducts");
      this.products = products;
    } catch (e) {
      this.setResponseError({ error: e });
    }
  },
  computed: {
    numberOnly: () => numberOnly,
    unitTypes() {
      if (this.formData && this.formData.product_id) {
        const selectedProduct = this.products.find(
          (item) => this.formData.product_id === item.id
        );
        if (selectedProduct) {
          return selectedProduct.unitTypes;
        }
      }
      return [];
    },
  },
};
</script>
